import apiClient from "./middleware";

export interface ClaimPolicyPatchSummaryResponse {
  windowDays: number;
  totalPatchedClaims: number;
  totalPatchedVideos: number;
  patchedClaimsInWindow: number;
  patchedVideosInWindow: number;
  lastMonetisationSyncAt: string | null;
}

export interface ClaimPolicyMonetisationMonthPoint {
  month: string;
  total: number;
}

export interface ClaimPolicyMonetisationVideoPoint {
  videoId: string;
  claimId: string | null;
  claimedAt: string | null;
  totalSinceClaim: number;
  monthly: ClaimPolicyMonetisationMonthPoint[];
}

export interface ClaimPolicyMonetisationResponse {
  windowMonths: number;
  totalMonetisation: number;
  byMonth: ClaimPolicyMonetisationMonthPoint[];
  byVideo: ClaimPolicyMonetisationVideoPoint[];
  lastSyncedAt: string | null;
}

export interface AssetsByClaimedDateBucket {
  claimMonth: string;
  assetCount: number;
}

export interface AssetsByClaimedDateResponse {
  totalAssets: number;
  buckets: AssetsByClaimedDateBucket[];
}

export interface ClaimPolicyUpdatedClaimsRow {
  videoId: string | null;
  claimId: string | null;
  claimedAt: string | null;
  updatedAt: string | null;
  sourceDocumentId: string;
  rawRecord: Record<string, string | number | boolean | null>;
}

export interface ClaimPolicyUpdatedClaimsResponse {
  limit: number;
  rows: ClaimPolicyUpdatedClaimsRow[];
}

export const claimPolicyPatchDashboardApi = {
  getSummary: async (
    windowDays = 30
  ): Promise<ClaimPolicyPatchSummaryResponse> => {
    const response = await apiClient.get("/claim-policy-patch-dashboard/summary", {
      params: { windowDays },
    });
    return response.data;
  },

  getMonetisation: async (
    windowMonths = 12
  ): Promise<ClaimPolicyMonetisationResponse> => {
    const response = await apiClient.get(
      "/claim-policy-patch-dashboard/monetisation",
      {
        params: { windowMonths },
      }
    );
    return response.data;
  },

  getAssetsByClaimedDate: async (
    windowMonths = 12
  ): Promise<AssetsByClaimedDateResponse> => {
    const response = await apiClient.get(
      "/claim-policy-patch-dashboard/assets-by-claimed-date",
      {
        params: { windowMonths },
      }
    );
    return response.data;
  },

  getUpdatedClaims: async (
    limit = 1000
  ): Promise<ClaimPolicyUpdatedClaimsResponse> => {
    const response = await apiClient.get("/claim-policy-patch-dashboard/updated-claims", {
      params: { limit },
    });
    return response.data;
  },

  getUpdatedClaimsExport: async (
    limit = 10000
  ): Promise<ClaimPolicyUpdatedClaimsResponse> => {
    const response = await apiClient.get(
      "/claim-policy-patch-dashboard/updated-claims/export",
      {
        params: { limit },
      }
    );
    return response.data;
  },
};
